'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    assign = require('react/lib/Object.assign'),
    ZineStore = require('./ZineStore'),
    update = require('react/lib/update'),
    { createStore } = require('../utils/StoreUtils');

var _zineDraft = null;

var ZineDraftStore = createStore({
  isEditing() {
    return !!_zineDraft;
  },

  getActiveDraft() {
    return _zineDraft;
  }
});

ZineDraftStore.dispatchToken = AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([ZineStore.dispatchToken]);

  var action = payload.action;

  switch (action.type) {
  case ActionTypes.CREATE_ZINE_DRAFT:
    _zineDraft = assign(
      action.isNew ? { isNew: true } : {},
      action.zine
    );
    ZineDraftStore.emitChange();
    break;

  case ActionTypes.UPDATE_ZINE_DRAFT:
    var zineUpdate = {};
    zineUpdate[action.key] = {
      $set: action.value
    };
    _zineDraft = update(_zineDraft, zineUpdate);
    ZineDraftStore.emitChange();
    break;

  case ActionTypes.DESTROY_ZINE_DRAFT:
  case ActionTypes.UPDATE_ZINE_SUCCESS:
  case ActionTypes.CREATE_ZINE_SUCCESS:
    _zineDraft = null;
    ZineDraftStore.emitChange();
    break;
  }
});

module.exports = ZineDraftStore;


/** WEBPACK FOOTER **
 ** ./stores/ZineDraftStore.js
 **/